// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"3a6b74c6","387":"bc327fae","488":"29b71886","511":"3d723632","658":"7a310863","973":"0c5affd8"}[chunkId] + ".chunk.js";
};